import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JbActivityHeaderModule, JbDialogModule } from 'jb-component-library';

import { LegendModule } from '../../../../shared/legend';
import { UIModule } from '../../../../shared/ui';
import { RegionsV2Module } from '../region-selector-v2';
import { RegionSelectorV2DialogComponent } from './region-selector-dialog-v2.component';

const MODULES = [
  CommonModule,
  UIModule,
  ReactiveFormsModule,
  FormsModule,
  LegendModule,
  RegionsV2Module,
  JbDialogModule,
  JbActivityHeaderModule,
];

const DECLARATIONS = [RegionSelectorV2DialogComponent];
@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class RegionSelectorDialogModule {}
